import { render, staticRenderFns } from "./ContactNoteByReason.vue?vue&type=template&id=cf585550&scoped=true&"
import script from "./ContactNoteByReason.vue?vue&type=script&lang=js&"
export * from "./ContactNoteByReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf585550",
  null
  
)

export default component.exports